import { useEffect } from 'react';

export const useServiceTracking = (serviceName: string) => {
  useEffect(() => {
    // Track service page view with your analytics service
    // Add your analytics tracking code here
  }, [serviceName]);

  const handleAppointmentClick = () => {
    if (localStorage.getItem('cookieConsent')) {
      const { analytics } = JSON.parse(localStorage.cookieConsent);
      if (analytics && typeof window.fbq === 'function') {
        window.fbq('track', 'Contact');   // or 'Schedule'
      }
    }
    // Track appointment request with your analytics service
    // Add your analytics tracking code here
  };

  return {
    handleAppointmentClick
  };
}; 